import { render } from "./jhi-footer.vue?vue&type=template&id=7662a689&ts=true"
import script from "./jhi-footer.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-footer.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__